/** @jsx jsx */
import { Link, useConfig } from 'docz';
import * as styles from 'gatsby-theme-docz/src/components/Logo/styles';
import { Flex, jsx, useColorMode } from 'theme-ui';
import { getPublicUrl } from '../../helpers';
import { Image } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Logo = function Logo() {
  var config = useConfig();

  var _useColorMode = useColorMode(),
      colorMode = _useColorMode[0];

  var _ref = config.themeConfig.logo || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src;

  var len = (config.title || '').length;
  var imagePath = typeof src === 'object' ? src[colorMode] : src;
  return jsx("div", {
    sx: styles.logo,
    "data-testid": "logo"
  }, jsx(Link, {
    to: "/",
    sx: styles.link
  }, jsx(Flex, {
    sx: {
      alignItems: 'center',
      flexDirection: 'row',
      lineHeight: 1.2
    }
  }, imagePath ? jsx(Image, {
    className: "logo",
    src: getPublicUrl(config.base, imagePath),
    width: width,
    height: "auto",
    alt: config.title
  }) : null, jsx("h5", {
    sx: {
      fontFamily: "'Montserrat', sans-serif",
      color: 'title'
    },
    className: len > 12 && imagePath ? 'h-sm' : ''
  }, config.title))));
};

if (typeof Logo !== 'undefined' && Logo && Logo === Object(Logo) && Object.isExtensible(Logo) && !Logo.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Logo, '__filemeta', {
    configurable: true,
    value: {
      name: "Logo",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Logo/index.js"
    }
  });
}